//import 'bootstrap/js/src/carousel';
//import 'bootstrap/js/src/collapse';
//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/button';
import { videoModal } from './video-modal';
import './carousel';
//import './animations';
//import './auto-headings-scroll';
//import Floaty from './floaty';
//Change nav behaviour
window.addEventListener('load', function () {
    var navbarToggle = document.querySelectorAll('a.mobile-menu');
    var mobileMenu = document.querySelector('.header-menu.mobile');
    navbarToggle === null || navbarToggle === void 0 ? void 0 : navbarToggle.forEach(function (elm) { return elm.addEventListener('click', function () {
        if (mobileMenu.classList.contains('show')) {
            mobileMenu.classList.toggle('show');
            mobileMenu.classList.toggle('hiding');
            setTimeout(function () {
                mobileMenu.classList.toggle('hiding');
            }, 100);
        }
        else {
            mobileMenu.classList.toggle('showing');
            setTimeout(function () {
                mobileMenu.classList.toggle('show');
                mobileMenu.classList.toggle('showing');
            }, 50);
        }
    }); });
    try {
        //@ts-ignore
        Typekit.load({
            async: true
        });
    }
    catch (e) { }
    var videos = document.querySelectorAll('.video');
    videos === null || videos === void 0 ? void 0 : videos.forEach(function (elm) {
        var _a;
        var modal = elm.querySelector('.mobile-video__modal');
        (_a = elm.querySelector('.close-modal')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            modal.classList.remove('show');
        });
        elm.addEventListener('click', function (event) {
            event.preventDefault();
            modal.classList.add('show');
            new videoModal(elm.href, modal.querySelector('iframe'));
        });
    });
});
